import React from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import { getToken } from '../utils/get-token';
import geojsonExtent from '@mapbox/geojson-extent';
import { ActionCreators } from '../redux/action-creators';

// Access token from mapbox-map-design
mapboxgl.accessToken = getToken();

class Overview extends React.PureComponent {
  mapRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      map: null
    };
  }

  componentDidUpdate() {
    const { geojson, activeFeature } = this.props;
    const { map } = this.state;
    if (map && map.loaded()) {
      map.getSource('geojson').setData(geojson);
      map.fitBounds(geojsonExtent(geojson), {
        duration: 0,
        padding: 24
      });

      map.getSource('geojson-active').setData({
        type: 'FeatureCollection',
        features: [activeFeature]
      });
    }
  }

  componentDidMount() {
    const { geojson, activeFeature } = this.props;
    const map = new mapboxgl.Map({
      container: this.mapRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      attributionControl: false
    });

    // Disable some interactions
    map.scrollZoom.disable();
    map.boxZoom.disable();
    map.dragRotate.disable();
    map.keyboard.disable();
    map.doubleClickZoom.disable();
    map.touchZoomRotate.disable();

    map.on('load', () => {
      map.fitBounds(geojsonExtent(geojson), {
        duration: 0,
        padding: 24
      });

      map.addSource('geojson', {
        type: 'geojson',
        data: geojson
      });

      map.addSource('geojson-active', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [activeFeature]
        }
      });

      map.addLayer({
        id: 'result-active',
        type: 'circle',
        source: 'geojson-active',
        paint: {
          'circle-radius': 6,
          'circle-stroke-width': 3,
          'circle-color': '#a0aeed',
          'circle-stroke-color': 'white'
        }
      });

      map.addLayer(
        {
          id: 'results',
          type: 'circle',
          source: 'geojson',
          paint: {
            'circle-radius': 6,
            'circle-stroke-width': 3,
            'circle-color': '#4264fb',
            'circle-stroke-color': 'white'
          }
        },
        'result-active'
      );

      map.on('mouseenter', 'results', () => {
        map.getCanvas().style.cursor = 'pointer';
      });

      map.on('mouseleave', 'results', () => {
        map.getCanvas().style.cursor = '';
      });

      map.on('click', 'results', e => {
        ActionCreators.activeFeature(e.features[0]);
      });
    });

    this.setState({ map });
  }

  render() {
    return <div ref={this.mapRef} className="absolute top right left bottom" />;
  }
}

Overview.propTypes = {
  activeFeature: PropTypes.object,
  geojson: PropTypes.object
};

export { Overview };
